import React from 'react';
import Button from 'components/Buttons/Button';
import { PlusIcon as Plus } from '@heroicons/react/24/outline';
import Input from 'components/Form/Input2';
import { CheckIcon } from '@heroicons/react/24/outline';
import 'twin.macro';
import { useTranslation } from 'react-i18next';

interface Props {
  onAdd: (name: string) => void;
}

export function AddCustomOptionButton(props: Props) {
  const [text, setText] = React.useState<string | undefined>(undefined);
  const { t } = useTranslation(['common']);
  if (text === undefined) {
    return (
      <Button fill minimal icon={Plus} onClick={() => setText('')}>
        {t('common:buttons.other')}
      </Button>
    );
  }

  return (
    <div tw="flex">
      <div tw="max-w-[8rem] mr-2">
        <Input
          autoFocus
          large
          value={text}
          data-testid="add-custom-option-input"
          onChange={e => setText(e?.target?.value || '')}
          onBlur={() => {
            if (text === '') {
              setText(undefined);
              return;
            }
            props.onAdd(text);
            setText(undefined);
          }}
          onKeyPress={e => {
            if (e.key === 'Enter') {
              if (text === '') {
                setText(undefined);
                return;
              }
              props.onAdd(text);
              setText(undefined);
            }
          }}
        />
      </div>

      <Button
        icon={CheckIcon}
        minimal
        aria-label="Valider l'option"
        onClick={() => {
          if (text === '') {
            setText(undefined);
            return;
          }
          props.onAdd(text);
          setText(undefined);
        }}
      />
    </div>
  );
}
